import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import { projects } from "../../data/projects";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import styled from "styled-components";

gsap.registerPlugin(ScrollTrigger);

// Styled Components
const Section = styled.section`
  width: 100%;
  padding: 0;
`;

const ContainerInner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 24px;
`;

const Heading = styled.h1`
  font-size: 2.5rem;
  color: white;
  text-align: center;
  margin-bottom: 10px;

  .purple {
    color: #6c63ff;
  }
`;

const SubText = styled.p`
  color: white;
  text-align: center;
  margin-bottom: 50px;
`;

const CARD_WIDTH = 370;
const CARD_WIDTH_MOBILE = 300;
const CARD_GAP = 24;

const StackedCardsContainer = styled.div`
  position: relative;
  min-height: 500px;
  margin-bottom: 0;

  @media (max-width: 768px) {
    min-height: 420px;
  }
`;

const StackedCardWrapper = styled.div`
  width: ${CARD_WIDTH}px;
  height: auto;
  position: relative;

  @media (max-width: 768px) {
    width: ${CARD_WIDTH_MOBILE}px;
  }
`;

const RemainingProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, ${CARD_WIDTH}px);
  justify-content: center;
  gap: ${CARD_GAP}px;
  margin-top: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ShowButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 28px;
`;

function Projects() {
  const containerRef = useRef(null);
  const [showAll, setShowAll] = useState(false);

  const firstRow = projects.slice(0, 3);

useGSAP(() => {
    if (showAll) return; // don't run when grid is showing

    const cards = gsap.utils.toArray(".stacked-card");
    if (!cards.length) return;

    gsap.set(cards, {
      xPercent: -50,
      left: "50%",
      position: "absolute",
      y: (i) => i * 15,
      scale: (i) => 1 - i * 0.04,
      zIndex: (i) => cards.length - i,
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".projects-stack-container",
        start: "top 75%",
        end: "top 20%",
        scrub: 1,
      },
    });

    tl.to(cards, {
      xPercent: (i) => {
        const middleIndex = (cards.length - 1) / 2;
        const spreadMultiplier = 108;
        return (i - middleIndex) * spreadMultiplier - 50;
      },
      y: 0,
      scale: 1,
      stagger: 0,
      ease: "power2.inOut",
    });
  }, { scope: containerRef, dependencies: [showAll] }); // 👈 re-run on showAll change
  return (
    <Section ref={containerRef}>
      <ContainerInner>
        <Heading>
          Featured <strong className="purple">Projects</strong>
        </Heading>
        <SubText>Here are a few projects I've worked on recently.</SubText>

  {!showAll && (
  <StackedCardsContainer className="projects-stack-container">
    {firstRow.map((project) => (
      <StackedCardWrapper key={project.id} className="stacked-card">
        <ProjectCard {...project} />
      </StackedCardWrapper>
    ))}
  </StackedCardsContainer>
)}

{showAll && (
  <RemainingProjectsGrid>
    {projects.map((project) => (
      <ProjectCard key={project.id} {...project} />
    ))}
  </RemainingProjectsGrid>
)}

        {/* Show/Hide Button */}
        <ShowButtonWrapper>
          <Button onClick={() => setShowAll(!showAll)}>
            {showAll ? "Show Less" : "Show All Projects"}
          </Button>
        </ShowButtonWrapper>
      </ContainerInner>
    </Section>
  );
}

export default Projects;
